import clsx from 'clsx';
import React from 'react';

import useEventTracking from '@hooks/useEventTracking';
import { highlight_path } from '@routes';
import { ClickTarget, click } from '@tracking';
import { parameterize } from '@utils/formatting';

interface HighlightProps {
  className?: string;
  customPath?: string;
  highlight: string;
}

const Highlight = ({ className, customPath, highlight = '' }: HighlightProps) => {
  const { trackEvent } = useEventTracking();

  return (
    <a
      href={customPath ?? highlight_path(parameterize(highlight))}
      onClickCapture={() =>
        trackEvent(click({ clickTarget: ClickTarget.Highlight, clickText: highlight }))
      }
      className={clsx(
        'track-click mb-4 block font-suisse-intl-mono text-overline-md text-primary-magenta',
        className
      )}
      data-type="link"
      data-name="article highlight"
      data-location="feed"
    >
      {highlight}
    </a>
  );
};

export default Highlight;
